import styled from "styled-components";
import { media } from "../../styles/mixins";
import theme from "../../styles/theme";
import { ReactComponent as PokerCards } from "../../images/PokerCards.svg";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";

export const HomepageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 56px;

  ${media.up("LAPTOP")` 
    flex-direction: row;
    margin-top:  calc(144px + var(--nav-height));
    padding-bottom: 96px;
    justify-content: space-between;
    align-items: flex-start;
  `}
`;

export const WelcomeTextWrapper = styled.div`
  max-width: 70%;
  text-align: center;
  padding: 56px 0;

  ${media.up("LAPTOP")`
    width: 45%;
    text-align: left;
    padding: 0;
    margin-right: 32px;
  `}
`;

export const CardsImage = styled(PokerCards)`
  height: auto;
  max-width: 100%;

  ${media.up("LAPTOP")` 
    max-width: 50%;
  `}
`;

export const StartGameButton = styled(ButtonBordered)`
  width: 208px;
  margin-top: 48px;
`;

export const HomeHeading = styled.h1`
  font-weight: var(--fw-black);
  font-size: ${theme.fonts.sizes.m};
  line-height: ${theme.fonts.lineHeights.s};

  ${media.up("LAPTOP")` 
    font-size: ${theme.fonts.sizes.xl};
    line-height: ${theme.fonts.lineHeights.xl};
  `}
`;

export const HomeParagraph = styled.p`
  margin-top: 16px;
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xs};

  ${media.up("LAPTOP")` 
    margin: 24px 0 0 0;
    max-width: 326px;
    font-size: ${theme.fonts.sizes.s};
    line-height: ${theme.fonts.lineHeights.s};
  `}
`;
